import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';
import { Impact } from 'src/app/models/data/impact.model';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from './../../../environments/environment';
import { User } from 'src/app/models/data/user.model';
import { DropdownService } from '../dropdown/dropdown.service';

@Injectable({
  providedIn: 'root',
})
export class ImpactQuestionsService {
  impactQuestion = new Subject<Impact>();
  localUser!: User;
  private impact!: Impact;

  q: string = '';

  constructor(
    private http: HttpClient,
    private dropdownService: DropdownService,
  ) { }

  getImpactQuestion(questionNumber: number) {
    const question = questionNumber + 22;
    this.getUserData();
    let headers = new HttpHeaders({
      token: this.localUser.token,
      'Content-Type': 'application/json',
    });
    return this.http
      .get<Impact>(`${environment.apiUrl}/QA/${question}`, {
        headers: headers,
      })
      .pipe(
        map((res) => {
          const currentQuestion = new Impact(
            res.text as string,
            res.type,
            res.answer,
          );
          this.impact = currentQuestion;
          this.q = res.text as string;
          this.impactQuestion.next(this.impact);
        }),
      );
  }

  getUserData() {
    const user: {
      username: string;
      token: string;
      status: number;
    } = JSON.parse(localStorage.getItem('user') as string);
    this.localUser = user;
  }

  updateImpactAnswer(answer: String, id: number, updatePageStatus: boolean = true) {
    const impactQuestion = id + 22;
    this.getUserData();
    let headers = new HttpHeaders({
      token: this.localUser.token,
      'Content-Type': 'application/json',
    });
    // Send empty string directly - backend accepts empty strings for QA endpoints
    return this.http
      .put(
        `${environment.apiUrl}/QA/${impactQuestion}`,
        {
          answer: answer,
        },
        { headers: headers },
      )
      .subscribe({
        next: (res) => {
          console.log(res);
          if (updatePageStatus) {
            this.dropdownService.setPageCompletionStatuses();
          }
        },
        error: (error) => {
          console.error('Error updating impact answer:', error);
          // Log the full error for debugging
          if (error.error) {
            console.error('Error details:', error.error);
          }
        }
      });
  }

  getImpactObs() {
    return this.impactQuestion.asObservable();
  }

  qq() {
    return this.q;
  }
}
